export enum LayoutType {
	BackOffice = '9a78393d-97f6-43d2-8694-8e17b9f3216a',
	FrontOffice = '9a783957-64d7-47ed-ab82-214cc5a5c068',
}
